import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import AlertifyHelper from 'src/app/utils/utils';
import { OpeningService } from 'src/app/api/money/opening.service';
import { GeneralService } from 'src/app/api/config/general.service';
import { constants } from 'src/app/constants';
import { ToolsService } from 'src/app/utils/tools.service';
import SwalAlert from 'src/app/utils/swalalert';
import { HttpHeaders } from '@angular/common/http';
import { SearchCollaboratorsComponent } from 'src/app/components/search-collaborators/search-collaborators.component';
import { ExpenseService } from 'src/app/api/money/expense.service';
import { AmountTextService } from 'src/app/utils/amount-text.service';
import { AccountbankService } from 'src/app/api/finance/accountbank.service';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
declare var $: any;

@Component({
  selector: 'app-bookings-commission-extends',
  templateUrl: './bookings-commission-extends.component.html',
  styleUrls: ['./bookings-commission-extends.component.css']
})
export class BookingsCommissionExtendsComponent {
  @ViewChild(SearchCollaboratorsComponent) SearchCollaboratorsComponent: any;
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;

  @Output() onSubmitEvent = new EventEmitter<string>();
  branchofficeSlug: string = '';
  item: FormGroup;
  submitted: boolean = false;
  isEdit: boolean = false;

  // variables
  book: any = null;
  check_moneybox: boolean = false;
  boxselected: any = null;
  moneybox: any = null;
  validatealert: boolean = false;

  currencies: any = [];
  paymentmethods: any = [];
  accountbanks: any = [];

  userpositions: any = constants.USER.TYPES;
  user_client: any = constants.USER.TYPES[0];
  user_provider: any = constants.USER.TYPES[1];
  positionSelected: any = this.user_client.id;
  isPositionSelected: boolean = false;
  possitionValue: any = {};
  paymentMethodSelected: any = {};
  fileUrlImage: any = null;

  amount: any = 0;
  amount_last: any;
  amount_paid: any = 0;

  isCollaboratorSelected: boolean = false;
  collaboratorSelected: any = {};

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private openingService: OpeningService,
    private expenseService: ExpenseService,
    private generalService: GeneralService,
    private accountbankService: AccountbankService,
    private alertifyMsg: AlertifyHelper,
    public toolsService: ToolsService,
    private amountTextService: AmountTextService,
    private alert: SwalAlert
  ) {
    this.item = this.fb.group({
      currency_id: [null, [Validators.required]],
      paymentmethod_id: [
        constants.paymentmethod_init_id,
        [Validators.required]
      ],

      collaborator_id: [null],
      accountbank_id: [null],
      gloss: [null],
      amount: [null],
      reference_operation: [null],
      text_amount: [null],
      observation: [null],
      //variables from boook ======
      client_id: [null],
      booking_id: [null],
      total_hotel: [null],
      total_tour: [null]
    });
  }

  init(book: any) {
    // console.log(book);
    this.book = book;
    this.amount_paid = this.book.total - this.book.total_paid;
    let gloss_val =
      'codigo ' + this.book.code + '- N° PROF:' + this.book.reference_voucher;

    this.item.patchValue({
      amount: 0,
      client_id: this.book.client_id,
      booking_id: this.book.id,
      gloss: gloss_val
    });

    this.checkBoxSelected();
    this.getCurrencies();
    this.getAccountBanks();
    this.getPaymentmethods();

    setTimeout(() => {
      this.SearchCollaboratorsComponent.focused();
    }, 500);
  }

  checkBoxSelected() {
    let val_params = '';
    this.openingService.getCheckBoxSlected(val_params).subscribe({
      next: (data: any) => {
        if (!_.isNull(data.data)) {
          this.boxselected = data.data;
          this.getBoxOpening();
        }
      }
    });
  }

  getBoxOpening() {
    this.openingService.getBoxOpening(this.boxselected.id).subscribe({
      next: (data: any) => {
        this.validatealert = true;
        if (data.data) {
          this.check_moneybox = true;
          this.moneybox = data.data;
        }
      }
    });
  }

  getCurrencies() {
    this.generalService.listCurrencies().subscribe({
      next: (data: any) => {
        this.currencies = data.results;
        for (let i in this.currencies) {
          if (this.currencies[i].is_principal) {
            this.item.patchValue({
              currency_id: this.currencies[i].id
            });
          }
        }
      }
    });
  }

  getPaymentmethods() {
    this.generalService.listPaymentmethods().subscribe({
      next: (data: any) => {
        this.paymentmethods = data.results;
        this.changePaymentMethod();
      }
    });
  }

  changePaymentMethod() {
    let obj_ = this.toolsService.searchArrById(
      this.item.value.paymentmethod_id,
      this.paymentmethods
    );
    this.paymentMethodSelected = obj_;

    if (!this.paymentMethodSelected.associate_bank) {
      this.item.patchValue({
        accountbank_id: null,
        reference_operation: null
      });
    }
  }

  getAccountBanks() {
    this.accountbankService.all().subscribe({
      next: (data: any) => {
        this.accountbanks = data.results;
      }
    });
  }

  changeBankAccount(param: any) {
    let value_ = param.value;
    if (value_ == 'null') {
      value_ = null;
    }
    this.item.patchValue({
      accountbank_id: value_
    });
  }

  calculate_difference() {
    setTimeout(() => {
      let total_ = (
        Number(this.item.value.total_hotel) + Number(this.item.value.total_tour)
      ).toFixed(2);
      this.amount = total_;
    }, 50);
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (this.toolsService.validateSizeImg(file)) {
      this.fileUrlImage = event.target.files[0];
    }
  }

  selectedCollaboratorsSearch(item_: any) {
    this.isCollaboratorSelected = true;
    this.collaboratorSelected = item_;
    this.item.patchValue({
      collaborator_id: item_.id
    });
  }

  removeCollaborator() {
    this.isCollaboratorSelected = false;
    this.collaboratorSelected = {};
    this.item.patchValue({
      collaborator_id: null
    });
    setTimeout(() => {
      this.SearchCollaboratorsComponent.focused();
    }, 150);
  }

  preSave() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    if (this.validate()) {
      let options = {
        title: '¡Atención!',
        message:
          '¿Esta seguro(a) de registrar la comisión para la reserva ' +
          this.book.code +
          '?',
        cancel: 'Cancelar',
        confirm: 'Sí, CONFIRMAR !'
      };
      this.alert.confirmInfo(options).then((result: any) => {
        if (result.isConfirmed) {
          this.submitted = true;
          this.onSubmit();
        }
      });
    }
  }

  onSubmit() {
    let data: any = {};
    let total_amount = this.item.value.amount;
    this.item.patchValue({
      total_tour: total_amount,
      text_amount: this.amountTextService.letras(total_amount)
    });

    data.income = this.item.value;
    this.LoadingModalComponent.show();
    const formData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    formData.append('item', JSON.stringify(data));
    formData.append('url_image', this.fileUrlImage);

    if (!this.isEdit) {
      this.expenseService.saveCommissionBooking(formData).subscribe({
        next: (data: any) => {
          this.alertifyMsg.success('Registro realizado con éxito');
          (<any>$('#openExtendsBookingsCommission')).modal('hide');
          this.close();
          this.onSubmitEvent.emit(data);
          this.LoadingModalComponent.hide();
        },
        error: (err: any) => {
          console.error('Error:', err); // Muestra detalles del error en la consola
          this.LoadingModalComponent.hide();
        }
      });
    }
  }

  validate() {
    if (this.item.value.collaborator_id == null) {
      this.alertifyMsg.warning(
        'Debe seleccionar el colaborador que va recibir la comisión.'
      );
      this.SearchCollaboratorsComponent.focused();
      return false;
    }

    if (Number(this.item.value.amount) == 0) {
      this.alertifyMsg.warning(
        'El total S/. a comisionar no puede ser igual a cero o estar vacío'
      );
      (<any>$('#total_tour')).focus();
      return false;
    }

    return true;
  }

  close() {
    this.isEdit = false;
    this.paymentmethods = [];
    this.currencies = [];
    this.item.patchValue({
      amount: 0,
      total_tour: null,
      total_hotel: null,
      paymentmethod_id: constants.paymentmethod_init_id
    });
    (<any>$('#fileUrlImage')).val('');
    this.isCollaboratorSelected = false;
    this.collaboratorSelected = null;
    this.fileUrlImage = null;
  }

  showloaderModal() {
    (<HTMLInputElement>document.getElementById('loading_box')).style.display =
      'block';
  }

  hideloaderModal() {
    (<HTMLInputElement>document.getElementById('loading_box')).style.display =
      'none';
  }
}
